// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const COMPETITION = "S\u00fa\u0165a\u017e";
export const FORUM_POSTS_SHOW_MORE = "Viac diskusi\u00ed...";
export const FORUM_WHERE_IS_DISCUSSED = "Kde sa diskutuje";
export const HOMEPAGE_POST_TYPE_COUNSELLING_TOPIC = "Porad\u0148a";
